export const translation_tl = {
    heading: "టాటా స్ట్రైవ్ | కార్య పథ్ ",
    subHeading: "టాటా ట్రస్ట్స్ స్కిల్ డెవలప్‌మెంట్ ఇనిషియేటివ్",
    partnership: "అభివృద్ధి చేసినవారు",
    poweredBy: "టాటా కమ్యూనికేషన్స్ ద్వారా ఆధారితం",
    welcomeText: "Discover your  interests and  match your career!",
    mobileNumber: "మొబైల్ నంబర్",
    dob: "పుట్టిన తేది",
    otp: "OTP పొందండి",
    enterOTP: "OTPని నమోదు చేయండి",
    validateOTP: "OTPని ధృవీకరించండి",
    resendOTP: "OTP ను మళ్ళీ పంపు",
    form_heading: "మీ ఆసక్తి తెలుసుకునే ముందు , మీ గురించి కొన్ని వివరాలు చెప్పండి!",
    firstName: "మొదటి పేరు",
    firstNamePlaceHolder: "మొదటి పేరు",
    lastName: "చివరి పేరు",
    lastNamePlaceHolder: "చివరి పేరు",
    qualification: "విద్య అర్హత ",
    gender: "లింగం",
    pincode: "పిన్ కోడ్",
    pincodePlaceHolder:"పిన్ కోడ్",
    village: "గ్రామం",
    villagePlaceHolder:"గ్రామం",
    district: "జిల్లా",
    districtPlaceHolder:"జిల్లా",
    districtPinPlaceHolder:"చెల్లుబాటు అయ్యే పిన్‌కోడ్‌ని నమోదు చేయండి",

    mailId: "మెయిల్ ఐడి",
    mailIdPlaceHolder:"మెయిల్ ఐడి",
    mandatoryFields: "*తప్పనిసరిగా పూరించండి",
    save: "Save",
    mobileInputError: "* 10 అంకెలు మాత్రమే",
    pincodeInputError: "* 6 అంకెలు మాత్రమే",
    onlyNumbersError: "* అంకెలు మాత్రమే",
    onlyCharError: "* అక్షరాలు మాత్రమే",
    noSpecialCharError: "* ప్రత్యేక అక్షరాలు ఉండకూడదు",
    mailError: "* చెల్లని మెయిల్ ఐడి",
    dobError: "* వయస్సు 16 సంవత్సరాల కంటే ఎక్కువ ఉండాలి",
    knowHowToPlayGame: "మీరు గేమ్‌ను ప్రారంభించే ముందు, గేమ్‌ను ఎలా ఆడాలో తెలుసుకోవడం ముఖ్యం. దయచేసి వీడియో చూడండి ",
    letsPlayGame: "Lets play the game !",
    confirmDialog: "నిర్ధారించండి!",
    yes:"అవును",
    no:"కాదు",
    invalidCode: "OTP తప్పు",
    ok: "OK",
    gamevideoConfirmation: "మీరు గేమ్ సూచనల వీడియోను చూశారని ఆశిస్తున్నాను",
    careervideoConfirmation: "మీరు కెరీర్ రిపోర్ట్ వీడియోను చూశారని ఆశిస్తున్నాను",
    doYouLikeThis: "Do you like this",
    like:"Like",
    dislike: "Dislike",
    mayBe: "Maybe",
    congratulations: "అభినందనలు,",
    lookAtResults: "మీ ఫలితాలను చూద్దాం",
    AfterGameMsg: "You just completed playing a career assessment designed to identify the jobs/career most suitable for you. A person’s interest in a particular work environment classifies him/her into a personality type. There are six personality types derived from Dr. John Holland's theory of careers and vocational choice, known as Holland Codes. Now based on your responses to the assessment your personality type/Holland code is",
    watchCareerVideo: "Watch video to understand your career report",
    clickHereButton: "Click Here",
    knowMoreAboutMatchingCareers : "to know about your most preferred personality type and matching career interest",
    ThankYouForPlayingGame: "గేమ్ ఆడినందుకు ధన్యవాదాలు.",
    understandBetter: "మిమ్మల్ని బాగా అర్థం చేసుకోవడంలో మాకు సహాయపడండి!",
    beforeChatBot: "మిమ్మల్ని బాగా అర్థం చేసుకోవడంలో మాకు సహాయపడండి! మీ కెరీర్ ఆసక్తులను తెలుసుకోవడానికి మీరు కేవలం ఒక అడుగు దూరంలో ఉన్నారు. మేము మీకు కొన్ని పరిస్థితులను చూపుతాము. మీకు బాగా సరిపోయే ఏదైనా ఒక ప్రతిస్పందనను ఎంచుకోండి.",
    clickToStart: "Click here to start",
    chatbotHeading: "దయచేసి మిమ్మల్ని బాగా అర్థం చేసుకోవడంలో మాకు సహాయపడటానికి ప్రశ్నలను పూర్తి చేయండి!",
    noCoursesText: "కెరీర్ ఎంపికలను అన్వేషించడానికి దయచేసి లింక్‌ని అనుసరించండి !",
    explore: "Explore",
    resultText1: "A person with a personality type",
    resultText2: ", is expected to flourish in the following professions.Click on each sector to explore further.",
    JobRole : "Job Role",
    sector: "Sector",
    recommendCounsellor: "We recommend you to reach our counsellor and understand your report better.",
    DownloadReport: "Download Report",
    reachToCounsellorButton: "Reach Out for Counselling",
    thankYouForCounsellorRequest: "Thank you for your request.Our counsellor will connect to you soon",
    contactUs1: "For queries, contact us on toll free number",
    csNumber: "1800-419-2112",
    contactUs2: "during working days, 10:00 am - 05:00 pm",
    contactUs3: " ", 
    askFeedback: "Did you like the game ?",
    thankYouForFeedback: "Thank you for your valuable feedback !",
    dear : "Dear",
    alertPageResultMsg:"You have completed all steps, Let's take a look at your results. Based on your responses to the assessment your personality type/Holland code is -",
    internetError: "Please wait.Page is loading.",
    confirmReplayOption: "Replaying the game will give you a new career report when you finish playing. Do you still want to continue?",
    ReplayGame: "Replay Game",
    gameVideo:"Ir2Wp8Gt4bc",
    beforeNameHappyText:"Happy to know you",
    afterNameHappyText:""  ,
    invalidPincode:"Please provide a valid pincode",
    interestedCourse: 'Interested Course',
    nearestCenter: 'Nearest Center'
};